export default function performanceReducers (state='', action)	 {
	switch (action.type) {
		case 'Loading':
			return action.payload;
		case 'performance':
			return action.payload;
		case 'Error':
			return action.payload;
		default:
			return state;
	}
}


export  function performanceAttributeReducers (state='', action)	 {
	switch (action.type) {
		case 'Loading':
			return action.payload;
		case 'attribute':
			return action.payload;
		case 'Error':
			return action.payload;
		default:
			return state;
	}
}